import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EmployeeFilter} from './employeeFilter';
import {FormsModule} from '@angular/forms';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import {TreeviewModule} from 'ngx-treeview';

const ngbModule = NgbModule.forRoot();
const treeviewModule = TreeviewModule.forRoot();

@NgModule({
    imports: [
        CommonModule, ngbModule, FormsModule, TranslateModule, AngularMultiSelectModule, treeviewModule,
    ],
    declarations: [EmployeeFilter],
    exports: [EmployeeFilter]
})

export class EmployeeFilterModule {

}




// WEBPACK FOOTER //
// ./src/app/employee/employeeFilter.module.ts